import { render, staticRenderFns } from "./index.vue?vue&type=template&id=17c64cfc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=17c64cfc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c64cfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c64cfc')) {
      api.createRecord('17c64cfc', component.options)
    } else {
      api.reload('17c64cfc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=17c64cfc&scoped=true", function () {
      api.rerender('17c64cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brandSubject/index.vue"
export default component.exports